import React from "react";
import Title from "../../components/TitleComponent";
import { Row, Col } from "react-bootstrap";
import { Image } from "react-bootstrap";
import Details from "../../components/DetailsComponent";
import { Helmet } from "react-helmet-async";

export default function PsychologyVsPsychiatry() {

  return (
    <>
      <Helmet>
        <title>Evaluare psihologica vs evaluare psihiatrica in tulburarile de dezvoltare la copii</title>
        <meta
          name="description"
          content="Diferentele dintre evaluarea psihologica si evaluarea psihiatrica in tulburarile de neurodezvoltare. Articol Asociatia PsiNapsis din Sibiu."
        />
        <link rel="canonical" href="https://www.psinapsis.ro/articles/psychologypsychiatryarticle" />
      </Helmet>

      <Row className="p-0 m-0">
        <Col className="d-none d-xl-block"></Col>
        <Col className="whiteBg p-0 m-0 pb-5 min-xl-screen-size">
          <Title title="𝗘𝘃𝗮𝗹𝘂𝗮𝗿𝗲 𝗽𝘀𝗶𝗵𝗼𝗹𝗼𝗴𝗶𝗰𝗮 𝘃𝘀 𝗲𝘃𝗮𝗹𝘂𝗮𝗿𝗲 𝗽𝘀𝗶𝗵𝗶𝗮𝘁𝗿𝗶𝗰𝗮 𝗶𝗻 𝘁𝘂𝗹𝗯𝘂𝗿𝗮𝗿𝗶𝗹𝗲 𝗱𝗲 𝗱𝗲𝘇𝘃𝗼𝗹𝘁𝗮𝗿𝗲 𝗹𝗮 𝗰𝗼𝗽𝗶𝗶" />

          <Details boldText="Psiholog sau psihiatru?" />

          <Details normalText="Vorbim despre doua categorii profesionale distincte a caror diferentiere este util de facut pentru parinti si pentru parcursul copilului." />

          <Details normalText="Psihologul clinician este profesionistul care finalizeaza studiile unei Facultati de Psihologie, a unui program de Masterat in domeniu si a unor specializari, pe cand psihiatrul este medic, acesta din urma finalizand Facultatea de Medicina, precum si specializarea adiacenta in Psihiatrie." />

          <Details normalText="Desi cele doua profesii lucreaza frecvent impreuna, rolurile lor sunt diferite si complementare." />

          <Details boldText="Evaluarea psihologica si evaluarea psihiatrica" />

          <Details normalText="Astfel, evaluarile sunt distincte. Psihologul clinician (cel care poate intocmi evaluari psihologice) investigheaza ariile de dezvoltare, identifica abilitatile, evalueaza functionalitatea copilului raportata la mediu, identifica comportamentele disruptive si functia acestora. Evaluarea psihologului are ca finalitate un raport de evaluare, dar si un plan de interventie/directii de interventie adaptate copilului evaluat." />

          <Details normalText="Evaluarea psihiatrica are ca finalitate stabilirea unui diagnostic medical prin raportarea la criterii prestabilite si intalnite in manualele de diagnostic statistic, identificarea unor cauze biologice si prescrierea medicatiei acolo unde acest lucru se impune. Evaluarea psihiatrica se face pe baza observatiei si a unei anamneze riguroase." />

          <Details boldText="Aspecte cheie" />

          <Details normalText="Un diagnostic medical insoteste copilul si ghideaza parintii si specialistii care vor implementa terapia de recuperare spre cele mai bune directii. Diagnosticul medical este unul care poate sa influenteze profund si pe termen lung familia unui copil, astfel este esential sa fie stabilit in baza unei anamneze atente, a unui proces de observatie riguros, a unei colaborari stranse psiholog clinician-psihiatru-familie." />

          <Details normalText={`Diagnosticul medical psihiatric este deseori resimtit cu greutate de catre apartinatori - "o eticheta sau o sentinta". Acesta este doar un punct de plecare ce trebuie privit cu claritate, un punct de plecare spre adaptare, integrare si sprijin al copilului care se confrunta cu o tulburare de neurodezvoltare. In practica am intalnit familii care s-au confuntat cu situatii diverse, unele care au primit diagnosticul cu usurinta, altele care au consultat diversi medici in decursul unei perioade ce se poate extinde chiar la nivelul anilor pentru a-l obtine sau a-l infirma.`} />

          <Details normalText="Interactiunea cu medicul psihiatru si implicit primirea unui diagnostic, poate sa vina inainte sau dupa evaluarea unui psiholog clinician, insa acesta din urma este cel care ajuta la identificarea abilitatilor copilului si a directiilor de urmat in terapia de recuperare prin elaborarea unui program personalizat de interventie." />

          <Details normalText="Cautarea, interactiunile, potentialul, resursele diadei parinte-copil cu tulburare de neurodezvoltare sunt diverse, un aspect insa foarte clar este nevoia de ghidaj real al familiei spre normalizare si traiul firesc, nu impotriva tulburarii, ci alaturi de aceasta." />

          <Image
            className="img-fluid my-4 mx-auto d-block"
            src="/images/psiholog vs psihiatru_lg.jpeg"
            alt="Evaluare psihologica vs evaluare psihiatrica in tulburarile de dezvoltare"
            style={{ maxWidth: "70%" }}
          />
        </Col>
        <Col className="d-none d-xl-block"></Col>
      </Row>
    </>
  );
}
